import { ApiMap } from '../ApiMap';
import { createApiCache, MAX_CACHE_TIMEOUT } from './createApiCache';
const refreshVideoCache = {};
export const setRefreshVideoCache = (playerId, value) => {
  refreshVideoCache[playerId] = value;
};
const Video2Cache = {};
export function getFetchVideo2ById(http) {
  const withVideoCache = createApiCache(http.get, ApiMap.VIDEO.getUrl, Video2Cache, MAX_CACHE_TIMEOUT);
  return videoId => {
    const clearCache = !!refreshVideoCache[videoId];
    setRefreshVideoCache(videoId, false);
    return withVideoCache(videoId, {}, {
      clearCache
    });
  };
}